module.exports = __webpack_public_path__ + "img/img-5.caf33918.jpg";